import LazyLoad from 'vanilla-lazyload';

new LazyLoad();
